<template>
    <div class="float-left">
        <b-button
        variant="danger"
        @click="abrirModal()">
            Reprovar Conformidade Técnica
        </b-button>
        <conformidade-tecnica-form
            operacaoProp="R"
            :pleito="pleito"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></conformidade-tecnica-form>
    </div>
</template>

<script>
import ConformidadeTecnicaForm from './ConformidadeTecnicaForm'

export default {
    components: {
        ConformidadeTecnicaForm
    },

    props: {
        pleito: {
            type: Object,
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(conformidadeTecnica){
            this.$store.dispatch('addRequest')
            let conformidadeTecnicaDto = {
                pleitoId : conformidadeTecnica.pleitoId,
                justificativa: conformidadeTecnica.justificativa,
            }
            
            // Detecta dinamicamente qual método usar baseado no serviço disponível
            let metodoReprovar = null
            if (this.dataServicos.reprovarConformidadeTecnicaUcic) {
                metodoReprovar = this.dataServicos.reprovarConformidadeTecnicaUcic(conformidadeTecnicaDto)
            } else if (this.dataServicos.reprovarConformidadeTecnica) {
                metodoReprovar = this.dataServicos.reprovarConformidadeTecnica(conformidadeTecnica.pleitoId)
            } else {
                this.$toast.error('Serviço de reprovação de conformidade técnica não disponível')
                this.$store.dispatch('removeRequest')
                this.fecharModal()
                return
            }
            
            metodoReprovar.then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Conformidade Técnica reprovada com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
